export default {
  recipeFilterNotAvailable: 'Wybierz zasób przed filtrowaniem według przepisu',
};
